<template>
  <section class="app-main">
    <BreadCrumb />
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </section>
</template>

<script>
import lang from '@/options/lang'
import BreadCrumb from './BreadCrumb'

export default {
  name: 'AppMain',
  computed: {

  },
  components: {
    BreadCrumb
  }
}
</script>

<style>
.app-main {
  min-height: calc(100vh);
  position: relative;
  overflow: hidden;
  border-left:1px solid #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/AppMain.vue